import styled from 'styled-components';

import { ItemText } from '@components/ui/search/SearchResultListStyle';

export const ItemErrorText = styled(ItemText)`
  color: rgb(226, 35, 27);
  font-size: 14px;
  padding: 1rem;
`;
